import { jsx as p } from "react/jsx-runtime";
import c from "react";
import { a as l } from "../../core-DVmjA3_O.js";
import { _ as f } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index52.css';const _ = "_raw-input_1iznz_1", d = {
  rawInput: _
};
function I(r) {
  const {
    className: o,
    onChange: t,
    elementRef: s,
    value: i,
    name: a,
    ...u
  } = r, m = c.useCallback((e) => {
    const n = e.currentTarget.value;
    t && t(
      n === "" ? void 0 : n,
      a,
      e
    );
  }, [a, t]);
  return /* @__PURE__ */ p(
    "input",
    {
      ...u,
      ref: s,
      className: f(
        d.rawInput,
        o
      ),
      name: l(a) ? String(a) : void 0,
      onChange: m,
      value: i ?? ""
    }
  );
}
export {
  I as default
};
